import type { RootState } from '../store'

export const appStateSelector = (state: RootState) => state.appState

export const activeMediaSelector = (state: RootState) =>
  state.appState.pages.main.activeMedia

export const mainActiveTabSelector = (state: RootState) =>
  state.appState.pages.main.activeTab
